import React from "react";

import { useWorkOSAuth } from "@worktango/d2c-service/workOSReact";

import { Button, Text } from "@kazoohr/confetti";
import { coalesce, coalesceFirstTruthy, doNothing } from "@kazoohr/helpers";
import { useTranslation } from "@kazoohr/internationalization";

import { useGetCurrentUserQuery } from "../../generated/apiHooks";

import styles from "./viewingAsBar.scss";

export function ViewingAsBar() {
  const { t } = useTranslation();
  const { user } = useWorkOSAuth();
  const { data } = useGetCurrentUserQuery({
    skip: !user,
    onError: doNothing, // Handled elsewhere
  });
  const currentUser = data?.currentUser;

  // Check if impersonating (takes precedence over org override)
  if (currentUser?.impersonator) {
    const targetName = coalesceFirstTruthy(
      `${coalesce(currentUser.firstName, "")} ${coalesce(
        currentUser.lastName,
        ""
      )}`.trim(),
      t("content:viewingAs.unknownUser")
    );

    return (
      <div className={styles["viewing-as-bar"]}>
        <div className={styles["viewing-as-content"]}>
          <Text>
            {t("content:viewingAs.impersonating", { name: targetName })}
          </Text>
          <Button
            variant="secondary"
            to="/sign-out"
            aria-label={t("content:viewingAs.exitImpersonation")}
          >
            {t("content:viewingAs.exit")}
          </Button>
        </div>
      </div>
    );
  }

  // Check if organization is overridden
  if (!currentUser?.organization || !currentUser?.organizationOverridden) {
    return null;
  }

  const handleExitOrgOverride = () => {
    const url = new URL(window.location.href);
    url.searchParams.set("overrideOrganizationId", "");
    window.location.href = url.toString();
  };

  return (
    <div className={styles["viewing-as-bar"]}>
      <div className={styles["viewing-as-content"]}>
        <Text>
          {t("content:viewingAs.accessingOrganization", {
            organization: currentUser.organization.name,
          })}
        </Text>
        <Button
          variant="secondary"
          onClick={handleExitOrgOverride}
          aria-label={t("content:viewingAs.exitOrganizationOverride")}
        >
          {t("content:viewingAs.exit")}
        </Button>
      </div>
    </div>
  );
}
